<template>
  <div>
    <form class="evollu-form">
      <!-- Block Detail -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t("iframe.blocks_builder.block_detail") }}
        </h5>
      </div>

      <div class="row col-12" style="margin-bottom: 0 !important">
        <!-- input name -->
        <div class="col-6 col-md-6">
          <va-input
            id="name"
            v-model="value.name"
            :label="$t('iframe.blocks_builder.block_name')"
            :placeholder="$t('iframe.blocks_builder.block_name')"
            @input="formErrors.clear('name')"
          />

          <small v-show="formErrors.has('name')" class="help text-danger">
            {{ $t(formErrors.get("name")) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input lang -->
        <div class="row col-md-6">
          <div class="col-12">
            <label class="form-label">{{
              $t("iframe.table_headings.lang")
            }}</label>
            <multiselect
              :options="langOptions"
              id="lang"
              v-model="value.lang"
              :custom-label="
                (opt) =>
                  opt.language_key
                    ? `${opt.emoji} ${$t(`language.${opt.language_key}`)}`
                    : 'N/A'
              "
              track-by="lang"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
              @input="formErrors.clear('lang')"
            >
              <span slot="noResult">{{ $t("patients.noResults") }}</span>
            </multiselect>

            <small v-show="formErrors.has('lang')" class="help text-danger">
              {{ $t(formErrors.get("lang")) }}
            </small>
          </div>
        </div>
        <!-- --- --->
      </div>
      <!------------>

      <div class="row col-12">
        <div class="row col-md-6 ml-0">
          <div class="col-12 p-0">
            <label class="form-label">{{ $t('iframe.table_headings.client') }}</label>
            <multiselect
              :options="clientOptions"
              id="client"
              v-model="client"
              label="name"
              track-by="name"
              :disabled="clientOptions.length === 1"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t('patients.noResults') }}</span>
            </multiselect>
          </div>

        </div>
      </div>

      <!-- Titles Section -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t("iframe.blocks_builder.title_section") }}
        </h5>
      </div>

      <div class="row col-12 mb-2">
        <!-- input titulo -->
        <div class="col-6 col-md-6">
          <va-input
            id="title"
            v-model="value.title"
            :label="$t('iframe.titles.title')"
            :placeholder="$t('iframe.titles.title')"
            @input="formErrors.clear('title')"
          />

          <small v-show="formErrors.has('title')" class="help text-danger">
            {{ $t(formErrors.get("title")) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input subtitulo -->
        <div class="col-6 col-md-6">
          <va-input
            id="subtitle"
            type="textarea"
            :min-rows="2"
            v-model="value.subtitle"
            :label="$t('iframe.titles.sub_subtitle')"
            :placeholder="$t('iframe.titles.sub_subtitle')"
            @input="formErrors.clear('subtitle')"
          />

          <small v-show="formErrors.has('subtitle')" class="help text-danger">
            {{ $t(formErrors.get("subtitle")) }}
          </small>
        </div>
        <!-- --- - -->
      </div>

      <!-- Noise Parameters -->
      <div>
        <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
          {{ $t("iframe.blocks_builder.noise_parameters") }}
        </h5>
      </div>

      <div class="row col-12 mb-2">
        <!-- input increment step -->
        <div class="col-4 col-md-4">
          <va-input
            id="increment_step"
            type="number"
            v-model.number="value.increment_step"
            :label="$t('iframe.titles.increment_step')"
            :placeholder="$t('iframe.blocks_builder.noise_block.default_increment_step')"
            @input="formErrors.clear('increment_step')"
          />

          <small v-show="formErrors.has('increment_step')" class="help text-danger">
            {{ $t(formErrors.get("increment_step")) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input prepare attenuation -->
        <div class="col-4 col-md-4">
          <va-input
            id="prepare_attenuation"
            type="number"
            v-model.number="value.prepare_attenuation"
            :label="$t('iframe.titles.prepare_attenuation')"
            :placeholder="$t('iframe.blocks_builder.noise_block.default_prepare_attenuation')"
            @input="formErrors.clear('prepare_attenuation')"
          />

          <small v-show="formErrors.has('prepare_attenuation')" class="help text-danger">
            {{ $t(formErrors.get("prepare_attenuation")) }}
          </small>
        </div>
        <!-- --- --->

        <!-- input sound noise threshold -->
        <div class="col-4 col-md-4">
          <va-input
            id="sound_noise_threshold"
            type="number"
            v-model.number="value.sound_noise_threshold"
            :label="$t('iframe.titles.sound_noise_threshold')"
            :placeholder="$t('iframe.blocks_builder.noise_block.default_noise_threshold')"
            @input="formErrors.clear('sound_noise_threshold')"
          />

          <small v-show="formErrors.has('sound_noise_threshold')" class="help text-danger">
            {{ $t(formErrors.get("sound_noise_threshold")) }}
          </small>
        </div>
        <!-- --- --->
        <!-- input noise start -->
        <div class="col-4 col-md-4">
          <va-input
            id="noise_start"
            type="number"
            v-model.number="value.noise_start"
            :label="$t('iframe.titles.noise_start')"
            :placeholder="$t('iframe.blocks_builder.noise_block.default_noise_start')"
            @input="formErrors.clear('noise_start')"
          />

          <small v-show="formErrors.has('noise_start')" class="help text-danger">
            {{ $t(formErrors.get("noise_start")) }}
          </small>
        </div>
        <!-- --- --->
        <!-- input noise end -->
        <div class="col-4 col-md-4">
          <va-input
            id="noise_end"
            type="number"
            v-model.number="value.noise_end"
            :label="$t('iframe.titles.noise_end')"
            :placeholder="$t('iframe.blocks_builder.noise_block.default_noise_end')"
            @input="formErrors.clear('noise_end')"
          />

          <small v-show="formErrors.has('noise_end')" class="help text-danger">
            {{ $t(formErrors.get("noise_end")) }}
          </small>
        </div>
        <!-- --- --->
        <!-- input noise end -->
        <div class="col-4 col-md-4">
          <va-input
            id="noise_end"
            type="text"
            v-model="value.cta_pass"
            :label="$t('iframe.titles.noise_cta_pass')"
            :placeholder="$t('iframe.titles.noise_cta_pass')"
            @input="formErrors.clear('cta_pass')"
          />

          <small v-show="formErrors.has('cta_pass')" class="help text-danger">
            {{ $t(formErrors.get("cta_pass")) }}
          </small>
        </div>

        <div class="col-6 col-md-6">
          <va-input
            id="pass_text"
            type="textarea"
            :min-rows="2"
            v-model="value.pass_text"
            :label="$t('iframe.titles.noise_pass_text')"
            :placeholder="$t('iframe.titles.noise_pass_text')"
            @input="formErrors.clear('pass_text')"
          />

          <small v-show="formErrors.has('pass_text')" class="help text-danger">
            {{ $t(formErrors.get("pass_text")) }}
          </small>
        </div>

        <div class="col-6 col-md-6">
          <va-input
            id="refer_text"
            type="textarea"
            :min-rows="2"
            v-model="value.refer_text"
            :label="$t('iframe.titles.noise_refer_text')"
            :placeholder="$t('iframe.titles.noise_refer_text')"
            @input="formErrors.clear('refer_text')"
          />

          <small v-show="formErrors.has('refer_text')" class="help text-danger">
            {{ $t(formErrors.get("refer_text")) }}
          </small>
        </div>
        <!-- --- --->

      </div>

      <!-- Upload section -->
      <div>
        <div>
          <h5 class="text-evollu-gray-light is-bold mb-0 pl-3 py-3">
            {{ $t("iframe.blocks_builder.media_section") }}
          </h5>
        </div>
        <!-- input is random -->
        <div class="row col-12 col-md-6 ">
           <span class="select is-fullwidth is-small pl-2">
                <va-checkbox
                  :label="$t('iframe.titles.is_random')"
                  id="checkbox-is-random"
                  :isCircle="true"
                  v-model="value.is_random"/>
              </span>

        </div>
        <!-- --- --->
        <br>
        <!--Header-->
        <div class="row col-12">
          <div class="col-md-2">
            <label class="header-lbl">{{
              $t("iframe.pages_configurator.headings.order")
            }}</label>
          </div>
          <div class="col-md-3">
            <label class="header-lbl">{{
              $t("iframe.pages_configurator.headings.media_name")
            }}</label>
          </div>
          <div class="col-md-2 w-100 d-flex justify-content-center">
            <label class="header-lbl">{{
              $t("iframe.pages_configurator.headings.actions")
            }}</label>
          </div>
        </div>
        <!--End Header-->
        <div v-if="value.lang" class="col-12" id="formItemsContainer">
          <!-- Items Area -->
          <div
            class="
              row
              col-12
              custom-border-outline
              justify-content-center
              align-content-center
            "
            style="height: 60px"
            v-if="addedItems.length === 0"
          >
            <label class="placeholder-label">{{
              $t("iframe.blocks_builder.noise_block.no_form_items")
            }}</label>
          </div>
          <div v-else>
            <div
              class="row col-12 mt-2 custom-border-outline align-content-center"
              style="height: 80px"
              v-for="(item, idx) of addedItems"
              :key="idx"
            >
              <div class="col-md-2 d-flex flex-column">
                <i
                  class="fa fa-caret-up"
                  v-bind:class="{
                    clickable: idx !== 0,
                    'sort-icon-disabled': idx === 0,
                  }"
                  @click="idx !== 0 ? handleSort('up', item) : null"
                />
                <i
                  class="fa fa-caret-down"
                  v-bind:class="{
                    clickable: idx !== addedItems.length - 1,
                    'sort-icon-disabled': idx === addedItems.length - 1,
                  }"
                  @click="
                    idx !== addedItems.length - 1
                      ? handleSort('down', item)
                      : null
                  "
                />
              </div>
              <div class="custom-multiselect col-md-3">
                <multiselect
                  :options="noiseItems"
                  id="formInputSelector"
                  v-model="item.name"
                  label="name"
                  track-by="id"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  placeholder="---"
                  open-direction="bottom"
                  :allow-empty="false"
                  :multiple="false"
                  :searchable="true"
                >
                  <span slot="noResult">{{ $t("patients.noResults") }}</span>
                </multiselect>
              </div>

              <div class="col-md-2 w-100 d-flex justify-content-center">
                <va-popover
                  :message="$t('iframe.actions.delete')"
                  placement="top"
                >
                  <i
                    class="report-action-icon fa fa-trash-o p-2 clickable"
                    @click.prevent.stop="removeItem(item)"
                  />
                </va-popover>
              </div>
            </div>
          </div>
          <!---------------->
        </div>
        <div v-else class="col-12" id="formItemsContainer">
          <div
            class="
              row
              col-12
              custom-border-outline
              justify-content-center
              align-content-center
            "
            style="height: 60px"
          >
            <label class="placeholder-label">{{
              $t("iframe.blocks_builder.noise_block.select_language")
            }}</label>
          </div>
        </div>

        <!-- Add new items -->
        <div v-if="value.lang && addedItems.length < 9" class="row col-12 mt-3 mb-4">
          <div class="col-12 mb-2">
            <label class="font-weight-bold">{{
              $t("iframe.blocks_builder.noise_block.add_new_item")
            }}</label>
          </div>
          <div class="col-md-2" style="padding-left: 40px">---</div>
          <div class="custom-multiselect col-md-3">
            <multiselect
              :options="noiseItems"
              id="addFormInputSelector"
              v-model="itemToAdd.name"
              label="name"
              track-by="id"
              select-label=""
              selected-label=""
              deselect-label=""
              placeholder="---"
              open-direction="bottom"
              :allow-empty="false"
              :multiple="false"
              :searchable="true"
            >
              <span slot="noResult">{{ $t("patients.noResults") }}</span>
            </multiselect>
          </div>
          <div class="col-md-2 w-100 d-flex justify-content-center">
            <div class="btn btn__round btn_add">
              <va-button
                :disabled="!itemToAdd.name"
                @click.prevent="onClickAddItem"
              >
                <i class="fa fa-plus"></i>
              </va-button>
            </div>
          </div>
        </div>
      </div>
      <!------------>
    </form>
  </div>
</template>

<script>
import Errors from "@/utils/StandardErrors";
import Multiselect from "vue-multiselect";
import { IframeService } from "@/api/IframeService";

export default {
  components: { Multiselect },
  props: {
    value: {
      type: Object,
      required: false,
    },
    clientOptions: {
      type: Array,
      required: true,
    },
    formErrors: {
      type: Object,
      required: false,
      default: () => {
        return new Errors();
      },
    },
  },
  data() {
    return {
      langOptions: this.$store.state.languages,
      itemToAdd: {
        name: null,
      },
      addedItems: [],
      noiseItems: [],
      client: {}
    };
  },
  watch:{
    'value.increment_step':{
      handler: function(value){
        this.value.increment_step = value.replace(/\D/g, '')
      }
    },
    'value.prepare_attenuation':{
      handler: function(value){
        this.value.prepare_attenuation = value.replace(/\D/g, '')
      }
    },
    'value.noise_start':{
      handler: function(value){
        this.value.noise_start = value.replace(/\D/g, '')
      }
    },
    'value.noise_end':{
      handler: function(value){
        this.value.noise_end = value.replace(/\D/g, '')
      }
    },
    client: function (val) {
      if (val) {
        this.value.client = val
      }
    }
  },
  mounted() {
    this.getNoiseItems();
    if(this.value && this.value.client_id) {
      this.value.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
      this.client = this.clientOptions.find(elem => elem.id === parseInt(this.value.client_id))
    }
  },
  methods: {
    getNoiseItems: function () {
      IframeService.getNoiseItems().then(({ data: noiseItems }) => {
        this.noiseItems = noiseItems;
        for (const index in this.value.items) {
          const item = this.value.items[index];
          this.addedItems.push({
            order: index,
            name: noiseItems.find((elem) => elem.name === item.name),
            item: item,
          });
        }
      });
    },
    getAddedItems: function () {
      return this.addedItems.map((it) => it.name);;
    },
    removeItem: function (formItem) {
      this.addedItems.splice(
        this.addedItems.findIndex(
          (item) => item.id === formItem.id && item.order === formItem.order
        ),
        1
      );
    },
    onClickAddItem: function () {
      if (this.itemToAdd.name !== null) {
        let lastIdx = this.addedItems.length;
        this.addedItems.push({
          order: lastIdx,
          name: this.itemToAdd.name,
          item: {
            name: this.itemToAdd.name,
          },
        });

        this.itemToAdd = {
          name: null,
        };
      }
    },
    handleSort: function (direction, formItem) {
      const currentElemIdx = this.addedItems.findIndex(
        (item) => item.id === formItem.id && item.order === formItem.order
      );
      const currentElemOrderTemp = formItem.order;

      if (direction === "down") {
        const nextElemOrderTemp = this.addedItems[currentElemIdx + 1].order;
        //update the current element to have the orderNr of the next one
        this.addedItems[currentElemIdx].order = nextElemOrderTemp;
        //update the next element to have the orderNr of the current one
        this.addedItems[currentElemIdx + 1].order = currentElemOrderTemp;

        //sort the array by order
        this.addedItems = this.addedItems.sort((a, b) =>
          a.order > b.order ? 1 : -1
        );
      } else if (direction === "up") {
        const lastElemOrderTemp = this.addedItems[currentElemIdx - 1].order;
        //update the current element to have the orderNr of the next one
        this.addedItems[currentElemIdx].order = lastElemOrderTemp;
        //update the next element to have the orderNr of the current one
        this.addedItems[currentElemIdx - 1].order = currentElemOrderTemp;

        //sort the array by order
        this.addedItems = this.addedItems.sort((a, b) =>
          a.order > b.order ? 1 : -1
        );
      }
    },
  },

};
</script>

<style scoped>
.custom-label{
  margin-top: 5px;
  color: rgb(41, 196, 169);
  max-width: calc(100% - 0.25rem);
  font-size: 0.625rem;
  letter-spacing: 0.0375rem;
  font-weight: bold;
  text-transform: uppercase;
  overflow: hidden;
  margin-bottom: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  transform-origin: top left;
}
.round {
  position: relative;
  bottom: -10px;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}
</style>
